import { render, staticRenderFns } from "./NodeClients.vue?vue&type=template&id=b79bc0e6&"
import script from "./NodeClients.vue?vue&type=script&lang=js&"
export * from "./NodeClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports